// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'primary', 'primary Fallback'"},"className":"__className_19c230","variable":"__variable_19c230"};